<template>
  <v-row class="drawer-right">
    <v-col cols="12" class="py-0">
      <v-card class="drawer-right__ranking" v-if="rankingList">
        <div class="drawer-right__stick d-flex justify-center text-h5 pt-2">
          <translate>Ranking</translate>
        </div>

        <v-timeline :reverse="true">
          <v-timeline-item
            v-for="(ranking, index) in rankingList"
            :key="index"
            color="#F2C94C"
            fill-dot
            small
            class="pb-0 px-3 elevation-0"
          >
            <v-card class="elevation-2 mb-3 text-center" v-show="ranking.number">
              <v-card-title class="ranking-title justify-center pa-2 pb-0">
                {{ ranking.name }}
              </v-card-title>
              <v-card-text class="ranking-subtitle">
                {{ ranking.number | splitNumber }}
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card>
      <div class="pa-5 white" v-else>
        <translate>The ranking is not available for this golf course</translate>
      </div>
      <!-- Information -->
      <InfomationCourseCard :isCourseAdmin="isCourseAdmin" @click="isEdit = !isEdit"/>

      <LatestReviewCard />

      <LatestVlogCard />
    </v-col>

    <DialogEditInfoGolfClub v-model="isEdit" :course="course" @action="action" />
  </v-row>
</template>

<script>
import LatestReviewCard from "@/components/Card/LatestReviewCard";
import LatestVlogCard from "@/components/Card/LatestVlogCard";
import DialogEditInfoGolfClub from "@/components/Dialog/DialogEditInfoGolfClub";
import InfomationCourseCard from "@/components/Card/InfomationCourseCard";

export default {
  components: {
    LatestReviewCard,
    LatestVlogCard,
    DialogEditInfoGolfClub,
    InfomationCourseCard
  },
  data() {
    return {
      gmapCenter: { lat: 45.502013, lng: -73.576271 },
      isEdit: false
    };
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    isCourseAdmin() {
      let course = this.course || {};
      let courseRole = course.courseRole || [];
      if (courseRole.length) {
        let courseAdmin =
          courseRole.findIndex((r) => r === "Course Admin") !== -1;
        if (courseAdmin) return true;
      }
      return false;
    },
    rankingList() {
      const rankWorld = this.course ? this.course.rank : ""
      const zoneRank = this.course ? this.course.zoneRank : ""
      const countryRank = this.course ? this.course.countryRank : ""
      const stateRank = this.course ? this.course.stateRank : ""
      const checkEmpty = [rankWorld, zoneRank, countryRank, stateRank].every((item) => !item)
      if( checkEmpty ) {
        return null
      } else {
        const list = []
        if(rankWorld) {
           list.push({ name: this.$gettext('World'), number: rankWorld })
        }
        if(zoneRank) {
          list.push({ name: this.course ? this.course.zoneRankName : "", number: zoneRank })
        }
        if(countryRank) {
          list.push({ name: this.course ? this.course.countryRankName : "", number: countryRank })
        }
        if(stateRank) {
          list.push({ name: this.course ? this.course.stateRankName : "", number: stateRank })
        }
        return list;
      }
    },
  },
  filters: {
    splitNumber: function (value) {
      if (!value) return '';
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
  methods: {
    action(val) {
      this.isEdit = val;
    },

  },
};
</script>

<style>
</style>